//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { IReportDateRangeInputItem } from './IReportDateRangeInputItem';
import { IReportStudentIDsInputItem } from './IReportStudentIDsInputItem';
import { MakeUpCreditsReportDetailLevel, ReportType } from './Enums';

export class MakeUpCreditsReportInputItem extends ReportInputItem implements IReportDateRangeInputItem, IReportStudentIDsInputItem {
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    StudentIDs: string[] = [];
    DetailLevel: MakeUpCreditsReportDetailLevel = MakeUpCreditsReportDetailLevel.EventCategory;
    IncludeCreditsFromBeforeStartDate: boolean = false;
    override readonly Type: ReportType = ReportType.MakeUpCredits;

    constructor(initializer?: Partial<Omit<MakeUpCreditsReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "MakeUpCreditsReportInputItem";
}
